import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { apiConfigsApi } from '@/api/api-configs.api';
import type {
  CasinoApiConfig,
  LambdaApiConfig,
  OpenAIApiConfig,
} from '@/types/api-config.types';

const keys = {
  casino: ['api-config', 'casino'] as const,
  openai: ['api-config', 'openai'] as const,
  lambda: ['api-config', 'lambda'] as const,
};

export function useCasinoConfig() {
  return useQuery({ queryKey: keys.casino, queryFn: apiConfigsApi.getCasino });
}

export function useOpenaiConfig() {
  return useQuery({ queryKey: keys.openai, queryFn: apiConfigsApi.getOpenai });
}

export function useLambdaConfig() {
  return useQuery({ queryKey: keys.lambda, queryFn: apiConfigsApi.getLambda });
}

export function useUpdateCasinoConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (cfg: CasinoApiConfig) => apiConfigsApi.updateCasino(cfg),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: keys.casino });
      toast.success('Configuración Casino guardada');
    },
    onError: () => toast.error('No se pudo guardar la configuración'),
  });
}

export function useUpdateOpenaiConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (cfg: OpenAIApiConfig) => apiConfigsApi.updateOpenai(cfg),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: keys.openai });
      toast.success('Configuración OpenAI guardada');
    },
    onError: () => toast.error('No se pudo guardar la configuración'),
  });
}

export function useUpdateLambdaConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (cfg: LambdaApiConfig) => apiConfigsApi.updateLambda(cfg),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: keys.lambda });
      toast.success('Configuración Lambda guardada');
    },
    onError: () => toast.error('No se pudo guardar la configuración'),
  });
}
